import styled from "@emotion/styled";
import { RangeCalendar } from "react-aria-components";

export const StyledRangeCalendar = styled(RangeCalendar)`
  width: fit-content;
  max-width: 100%;
  color: ${({ theme }) => theme.colors.text.primary};

  /* Range cells form a continuous bar: interior cells are flat, and the
     start/end cells flatten only their inward-facing edges. Scoped to
     descendants of RangeCalendar so single-date MDSCalendar selections keep
     the default rounded shape. The base rule from MDSCalendarCell applies
     border-radius: 6px to every cell; bumping specificity here with the
     attribute selector + descendant context overrides it. */
  & [data-selected] {
    border-radius: 0;
  }

  & [data-selection-start] {
    border-start-start-radius: 6px;
    border-end-start-radius: 6px;
  }

  & [data-selection-end] {
    border-start-end-radius: 6px;
    border-end-end-radius: 6px;
  }
`;

export const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  margin: 0 ${({ theme }) => theme.spacing["2"]};
`;
